angular.module('vastdesk').
  component('bridVideoPlayer',  {
    bindings: {
      playerId: '@',
      videoUrl: '@',
      imageUrl: '@'
    },
    template: '<div class="video-player" id="{{$bridVideoPlayerCtrl.playerId}}"></div>',
    controllerAs: '$bridVideoPlayerCtrl',
    controller: ['$rootScope', '$element', function($rootScope, $element) {

      var self = this;

      var hasVideoUrl = function() {
        return self.videoUrl &&
          self.videoUrl !== 'undefined' &&
          self.videoUrl !== 'null';
      };

      var playerElementReady = function() {
        return self.playerId && document.getElementById(self.playerId);
      };

      var initPlayer = function() {
        if (!hasVideoUrl() || !playerElementReady()) {
          return;
        }

        var playerConfig = {
          "id": 8272,
          "playerId": 20206,
          "Skin": {
            "id": 1
          },
          "video": {
            "image": self.imageUrl,
            "source": {
              "src": self.videoUrl
            }
          }
        };

        Brid.forceConfigLoad = true;

        $bp?.(self.playerId, playerConfig);
      };

      var initPlayerWhenReady = function(attempt) {
          if (typeof Brid !== 'undefined' && hasVideoUrl() && playerElementReady()) {
            initPlayer();
          return;
        }

        if (attempt < 50) {
          setTimeout(function() {
            initPlayerWhenReady(attempt + 1);
          }, 100);
        }
      };

      $rootScope.$on('bridVideoChange', function(e, args) {
        if (args.playerId === self.playerId) {
          self.videoUrl = args.videoUrl;
          self.imageUrl = args.imageUrl;

          $bp?.(self.playerId)?.destroy?.();

          $element.append('<div class="video-player" id="' + self.playerId + '"></div>');

          setTimeout(function() {
            initPlayerWhenReady(0);
          }, 0);
        }
      });

      this.$onInit = function() {
        setTimeout(function() {
          initPlayerWhenReady(0);

          $('a[data-toggle="tab"][href="#tabSettings"]').on('shown.bs.tab', function (e) {
            $bp?.(self.playerId)?.onResizeFunc?.();
          });
        }, 0);
      };

    }]
});
